import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader';
import useContract from '../../hooks/useContract';
import formatAddress from '../../helpers/formatAddress';

interface Props extends Pick<React.ComponentProps<typeof PageHeader>, 'heading' | 'subheading'> {}

const ContractSwitcherHeader: React.FC<Props> = ({
  heading,
  subheading,
}) => {
  const {
    contracts = [],
    selectContract,
    selectedContract,
  } = useContract();

  const { t } = useTranslation();

  const contractMenuItems = contracts.reduce((acc, curr) => {
    // Fix: Previously used only accountId as the key,
    // which caused contracts with the same accountId to overwrite each other -> not all contracts being shown in the selector
    //
    // Now using a composite key (accountId + contract id) to ensure each contract is uniquely represented
    if (curr.accountId && curr.address) {
      const key = `${curr.accountId}_${curr.id}`; // unieke key
      const label = `${t('contractSwitcher.deliveryAddress')}: ${formatAddress(curr.address, {
        city: false,
        postalCode: false,
      })}`;

      return {
        ...acc,
        [key]: label,
      };
    }

    return acc;
  }, {} as Record<string, string>);

  return (
    <>
      <PageHeader
        heading={heading}
        subheading={subheading}
      >
        {contracts.length > 1 && (
        <PageHeader.Menu
          items={contractMenuItems}
          onChange={selectContract}
          defaultItem={`${selectedContract?.accountId}_${selectedContract?.id}`}
        />
        )}
      </PageHeader>
    </>
  );
};

export default ContractSwitcherHeader;
